<template>
  <div>
    <div class="container">
      <div class="urlc__title-container">
        <div class="urlc__title-left">
          <div class="urlc__tabs function-tabs">
            <div
              v-tooltip.bottom-start="{content: 'Filter', ...tooltipOptions}"
              class="urlc__tab"
              :class="[{urlc__tab__enabled: tableFilters.length}]"
              @click="showFilters = !showFilters"
            >
              <base-material-design-icon
                icon="filter"
                class="urlc__icon"
              />
            </div>
            <div
              id="add-tab-dropdown-container"
              v-tooltip.bottom-start="{content: 'Modifications', ...tooltipOptions}"
              class="urlc__tab"
              @click="$refs.select.open()"
            >
              <base-select
                id="add-tab-dropdown"
                ref="select"
                :is-hide-arrow="true"
                :options="dataModalOptions"
                align-left
                :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
                :header-style="{height: '20px !important'}"
                :prop-list-style="{cursor: 'pointer'}"
                show-top-border
                :max-height-list="500"
                :placeholder-icon="'plusCircle'"
                :border-less="true"
                :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
                @change="openDataModal($event)"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Select All Rows', ...tooltipOptions}"
              class="urlc__tab"
              @click="selectAllRows"
            >
              <base-material-design-icon
                icon="check"
                class="urlc__icon"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Bulk Update', ...tooltipOptions}"
              class="urlc__tab"
              @click="openBulkUpdateModal()"
            >
              <base-material-design-icon
                icon="flash"
                class="urlc__icon"
              />
            </div>
          </div>
          <div class="urlc__filter_pills">
            <FilterChips
              :filters="tableFilters"
              :field-labels="fieldLabels"
              @delete="removeFilter($event)"
              @deleteAll="clearFilter(true)"
            />
          </div>
        </div>
        <div class="urlc__title-right">
          <div class="urlc__tabs page-tabs">
            <div
              v-tooltip.bottom-start="{content: 'Column Editor', ...tooltipOptions}"
              class="urlc__tab"
              @click="$modal.show('column-editor')"
            >
              <base-material-design-icon
                icon="tableColumnPlusAfter"
                class="urlc__icon"
              />
            </div>
            <div
              v-tooltip.bottom-start="{content: 'Saved Views', ...tooltipOptions}"
              class="urlc__tab"
              :class="[{urlc__tab__enabled: savedViewSelected}]"
              @click="openCreateTableViewModal"
            >
              <base-material-design-icon
                icon="copy"
                class="urlc__icon"
              />
            </div>
            <div
              id="export-tab-dropdown-container"
              v-tooltip.bottom-start="{content: 'Export', ...tooltipOptions}"
              class="urlc__tab"
              @click="$refs.export.open()"
            >
              <base-select
                id="export-tab-dropdown"
                ref="export"
                :is-hide-arrow="true"
                :options="exportOptions"
                align-left
                :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
                :header-style="{height: '20px !important'}"
                :prop-list-style="{cursor: 'pointer'}"
                show-top-border
                :max-height-list="500"
                :placeholder-icon="'download'"
                :border-less="true"
                :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
                @change="exportData($event)"
              />
            </div>
          </div>
          <base-select
            v-model="pageSize"
            :options="paginationOptions"
            align-left
            :title-style="{'padding-left': '5px'}"
            :header-style="{backgroundColor: '#ffffff'}"
            show-top-border
            shift-label-right
            :select-style="{'margin': '5px', 'height': '34px !important', width: '100px !important'}"
            :prop-list-style="{cursor: 'pointer'}"
          />
        </div>
      </div>
      <div
        v-show="showFilters"
        class="urlc__filters"
      >
        <div class="urlc__filters_header">
          <span class="urlc__filters_title">
            Advanced Filtering
          </span>
          <base-material-design-icon
            icon="close"
            class="urlc__icon urlc__filters_close"
            @click="showFilters = false"
          />
        </div>
        <base-census-filter-table
          :columns="getRefreshedColumns()"
          :all-filters="tableFilters"
          :order="filterFieldOrder"
          :get-filter-fields="getFilterFields"
          :field-labels="fieldLabels"
          :is-visible="showFilters"
          @setFilter="setFilter($event, true)"
          @clearFilter="clearFilter(true)"
          @removeFilter="removeFilter($event)"
          @close="showFilters = false"
        />
      </div>
      <div class="metrics">
        <div>
          <span class="metrics__metric">
            URLs
          </span>
          <span class="metrics__metric__filtered">
            {{ filteredUrlCount.toLocaleString('en') }}
          </span>
          <span
            v-if="filteredUrlCount < totalUrlCount"
            class="metrics__metric"
          >
            {{ totalUrlCount.toLocaleString('en')
            }}
          </span>
          <span
            v-else
            class="metrics__metric"
          />
        </div>
        <div>
          <BaseProgressRing
            :current="filteredUrlCount"
            :total="totalUrlCount"
            class="progress-ring"
          />
        </div>
      </div>
      <div
        id="main-table"
        ref="table"
        onContextMenu="return(false)"
      />
    </div>
    <modal
      name="column-editor"
      v-bind="modalProps"
    >
      <ColumnEditor
        ref="column-editor"
        :columns="getRefreshedColumns()"
        @toggle="toggleColumnVisibility"
        @close="$modal.hide('column-editor')"
      />
    </modal>
    <modal
      name="bulk-update"
      v-bind="modalProps"
    >
      <BulkUpdate
        ref="bulk-update"
        :selected-ids="selectedIds"
        :all-ids="filteredUrls"
        :url-attribute-ids="urlAttributeIds"
        @close="$modal.hide('bulk-update')"
        @apply="applyBulkUpdate($event)"
      />
    </modal>
    <modal
      name="history"
      v-bind="modalProps"
    >
      <base-url-history-modal
        :url="selectedUrl"
        @close="closeHistoryModal"
      />
    </modal>
    <modal
      name="add-urls"
      v-bind="modalProps"
    >
      <CreateUrls
        ref="add-urls"
        :mapped-urls="urlList"
        :web-property-patterns="webPropertyPatterns"
        @close="$modal.hide('add-urls')"
        @applyUrls="applyUrls($event)"
      />
    </modal>
    <modal
      name="create-table-view"
      v-bind="modalProps"
    >
      <CreateTableView
        ref="create-table-view"
        :views.sync="savedViews"
        :client-id="selectedClient && selectedClient._id"
        :user-id="currentUser && currentUser._id"
        :current-table-view-hash.sync="currentTableViewHash"
        @close="$modal.hide('create-table-view')"
        @select="setTableView($event)"
        @apply="applySaveTableView($event)"
        @delete="handleDeleteTableView($event)"
      />
    </modal>
    <modal
      name="create-section"
      v-bind="modalProps"
    >
      <CreateSection
        ref="create-section"
        :data="sectionData"
        @apply="applySection($event)"
        @cancel="$modal.hide('create-section')"
      />
    </modal>
    <modal
      name="create-url-attribute"
      v-bind="modalProps"
    >
      <CreateUrlAttribute
        ref="create-url-attribute"
        :select-options="createUrlSelectOptions"
        @close="$modal.hide('create-url-attribute')"
      />
    </modal>
    <modal
      name="edit-url"
      v-bind="modalProps"
    >
      <UrlEdit
        ref="edit-url"
        :url-id="selectedUrl || 'create-new-url'"
        @edit="table.setData()"
        @close="$modal.hide('edit-url')"
      />
    </modal>
    <div
      v-if="isDataUpdating"
      class="urlc__update-loader"
    >
      <base-loader class="urlc__update-loader-ring" />
    </div>

    <base-material-design-icon
      ref="iconPencil"
      style="font-size:14px;"
      icon="edit"
    />
    <base-material-design-icon
      ref="iconQuestion"
      style="font-size:16px;vertical-align:top;"
      icon="questionCircle"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import baseModalProps from '@/common/BaseModalProps'

import Tabulator from 'tabulator-tables'
import ToasterService from '@/services/toasterService'
import tableColumns from './tableColumns'
import fieldLabels from './fieldLabels'
import BulkUpdate from './BulkUpdate'
import ColumnEditor from './ColumnEditor'
import CreateUrls from '../keyword-census/CreateUrls'
import CreateSection from '../sections/CreateUpdateSectionPopup'
import CreateUrlAttribute from '../url-attributes/AddNew'
import FilterChips from '../keyword-census/FilterChips'
import CreateTableView from '../keyword-census/CreateTableView'
import { cloneDeep, debounce, isEqual } from 'lodash'
import moment from 'moment'
import UrlEdit from './Edit'
import status from 'statuses'

const order = {
  // "attribute": 1,
  'url_attribute': 1,
  'content_brief_status': 2,
  'is_optimized': 3,
  'keyword_count': 4,
  'keyword_score_average': 5,
  'link_count': 6,
  'msv_1_total': 7,
  'msv_2_total': 8,
  'msv_3_total': 9,
  'msv_4_total': 10,
  'page_type': 11,
  'publish_date': 12,
  'section_name': 13,
  'url': 14,
  'url_status': 15,
  'writing_status': 16,
  'assigned_writer': 17,
  'assigned_strategist': 18,
  'http_response_url': 19,
  'http_response_code': 20,
  'published_url': 21
}

Tabulator.prototype.extendModule('filter', 'filters', {
  'Containing': function () { return true },
  'Word matching': function () { return true },
  'Exactly matching': function () { return true },
  'Begins with': function () { return true },
  'Ends with': function () { return true }
})

const SELECT_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]

export default {
  name: 'UrlCensus',
  components: { BulkUpdate, CreateTableView, CreateUrls, ColumnEditor, FilterChips, CreateSection, CreateUrlAttribute, UrlEdit },
  data() {
    return {
      table: null,
      tableData: [],
      fieldLabels: fieldLabels,
      filterFieldOrder: cloneDeep(order),
      isDataLoading: false,
      currentTableViewHash: null,
      savedViews: {},
      exportOptions: [
        {
          label: 'Analyst Export (CSV)',
          value: '/url_census/export?report_type=analyst'
        },
        {
          label: 'Aggregate Export (CSV)',
          value: '/url_census/export?report_type=analyst_aggregate'
        },
        {
          label: 'Bulk Update Export (CSV)',
          value: '/url_census/export?report_type=bulk_update'
        },
        {
          label: 'Data View Export (CSV)',
          value: '#download-csv'
        },
        {
          label: 'Data View Copy to Clipboard',
          value: '#copy-csv'
        }
      ],
      dataModalOptions: [
        {
          label: 'Create URL',
          value: 1
        },
        {
          label: 'Add URLs',
          value: 2
        },
        {
          label: 'Create Section',
          value: 3
        },
        {
          label: 'Create URL Attribute',
          value: 4
        }
      ],
      paginationOptions: [
        {
          label: '100',
          value: 100
        },
        {
          label: '250',
          value: 250
        },
        {
          label: '500',
          value: 500
        },
        {
          label: '1000',
          value: 1000
        }
      ],
      filteredUrls: [],
      filteredUrlCount: 0,
      totalUrlCount: 0,
      urlAttributeData: [],
      filteredMappedUrls: 0,
      allMappedUrls: 0,
      filteredRankingUrls: 0,
      allRankingUrls: 0,
      filteredMsv: {
        metric_msv_broad_adjusted_1: 0,
        metric_msv_broad_adjusted_2: 0,
        metric_msv_broad_adjusted_3: 0,
        metric_msv_broad_adjusted_4: 0
      },
      contentBriefValues: {},
      allMsv: [],
      isDataUpdating: false,
      showFilters: false,
      tableHelpers: {},
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow'
      },
      opts: {
        urls: [
          {
            value: -1,
            label: 'Not Set'
          }
        ],
        sources: [
          {
            value: -1,
            label: 'Not Set'
          }
        ]
      },
      selectedUrl: '',
      createUrlSelectOptions: SELECT_OPTIONS,
      webPropertyPatterns: [],
      sectionValues: {}
    }
  },
  computed: {
    ...mapState({
      selectedClient: 'selectedClient'
    }),
    ...mapState('urlCensus', ['tableFilters', 'pageTypes', 'urlStatuses', 'sections', 'contentBriefStatuses', 'msvLabels', 'urlList', 'writingStatuses']),
    ...mapState('users', ['users']),
    ...mapState('projectSettings', {
      sectionData(state) {
        return {
          opts: {
            is_active: [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }],
            target_geo: [{ value: -1, label: '--- Not Set ---' }, ...state.targetGeoOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)],
            target_device: [{ value: -1, label: '--- Not Set ---' }, ...state.targetDeviceOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)],
            target_locale: [{ value: -1, label: '--- Not Set ---' }, ...state.targetLocaleOptions.sort((a, b) => (a.label > b.label) ? 1 : -1)]
          },
          defaultSection: state.projectData
        }
      }
    }),
    modalProps() {
      const modalProps = {
        width: '75%'
      }
      return { ...baseModalProps, ...modalProps }
    },
    formattedUsers() {
      return this.users.reduce((acc, cur) => {
        acc[cur._id] = cur.name
        return acc
      }, {})
    },
    formattedUsersList() {
      let listUsers = Object.keys(this.formattedUsers).reduce((acc, cur) => {
        acc.push({
          label: this.formattedUsers[cur],
          value: cur
        })
        return acc
      }, [])
      listUsers = listUsers.sort((a, b) => {
        if (a.label >= b.label) {
          return 1
        } else {
          return -1
        }
      })
      return listUsers
    },
    pageSize: {
      get: function () {
        return this.table ? this.table.getPageSize() : 100
      },
      set: function (newValue) {
        this.table.setPageSize(newValue)
      }
    },
    savedViewSelected() {
      return Object.keys(this.savedViews).some(category => this.savedViews[category].some(view => view.id === this.currentTableViewHash))
    },
    isUserSuperAdmin() {
      return this.userRoles.includes('admin')
    },
    selectedIds() {
      return this.table ? this.table.getSelectedData().map(row => row.id) : []
    },
    urlAttributeIds() {
      return this.urlAttributeData.map(data => data.id)
    },
    rows() {
      return this.table ? this.table.getRows() : []
    },
    tableViewData() {
      return {
        filters: this.table ? [...this.table.getFilters(), ...this.table.getHeaderFilters()] : [],
        sorters: this.table ? this.table.getSorters().map(sorter => ({ dir: sorter.dir, column: sorter.field })) : [],
        columns: this.table ? this.table.getColumnLayout() : []
      }
    }
  },
  watch: {
    tableFilters: {
      handler() {
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
      },
      deep: true
    },
    tableData: {
      handler(newData) {
        this.table.replaceData(newData)
      },
      deep: true
    },
    tableViewData: {
      handler(newData) {
        this.handleTableViewDataChange(newData)
      },
      deep: true
    },
    clientId: {
      handler() {
        if (!this.isDataLoading) {
          this.getUsersByClient({ clientId: this.clientId })
          this.loadData()
          this.getProjectSettings(this.clientId)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('urlCensus', [
      'getUrlOpts',
      'getSourceOpts',
      'postBulkUpdate',
      'updateField',
      'getUrlTableHelpers',
      'getFilterFields',
      'updateTableFilters']),
    ...mapActions('sections', ['createSection']),
    ...mapActions('projectSettings', ['getProjectSettings']),
    ...mapActions('keywordCensus', [
      'postUrls',
      'getSavedViews',
      'deleteTableView',
      'patchTableView',
      'getTableView',
      'postTableView']),
    ...mapActions('users', [
      'getUsersByClient'
    ]),
    getHttpStatusText (code) {
      let text = ''
      // Some custom status codes are not supported - ie 430 used by Shopify
      try {
        text = status(code)
      } catch {
        text = code
      }
      return text
    },
    toggleColumnVisibility(field) {
      this.table.toggleColumn(field)
    },
    getUpdatedTableViewData() {
      const newFilters = this.table ? [...this.table.getFilters(), ...this.table.getHeaderFilters()] : []
      return {
        filters: newFilters,
        sorters: this.table ? this.table.getSorters().map(sorter => ({ dir: sorter.dir, column: sorter.field })) : [],
        columns: this.table ? this.table.getColumnLayout() : []
      }
    },
    debouncedHandleTableViewDataChange: debounce(async (changes, scope) => {
      const data = await scope.postTableView({ form: changes, clientId: scope.selectedClient._id, type: 'url_census' })
      scope.currentTableViewHash = data.data
      scope.$router.replace({ name: scope.$route.name, params: { id: data.data } })
      scope.$route.params.id = null
    }, 500),
    handleTableViewDataChange(changes) {
      this.debouncedHandleTableViewDataChange(changes, this)
    },
    getRefreshedColumns() {
      return this.table ? cloneDeep(this.table.getColumns()) : []
    },
    updateFilters() {
      const advancedFilters = this.table ? this.table.getFilters() : []
      const headerFilters = this.table ? this.table.getHeaderFilters() : []
      this.updateTableFilters({ advancedFilters, headerFilters })
    },
    selectAllRows() {
      this.selectedIds.length ? this.table.deselectRow() : this.table.selectRow()
    },
    setFilter(filters, setFromAdvancedFilterModal = false) {
      // handle 'in' filters set in adv. filter modal
      filters = filters.map(filter => {
        if (filter.type === 'in' && !Array.isArray(filter.value)) {
          filter.value = [filter.value]
        }
        return filter
      })
      filters = filters.filter(filter => {
        filter = {
          field: filter.field,
          type: filter.type,
          value: filter.value
        }
        if (setFromAdvancedFilterModal) {
          return filter
        }
        return this.tableFilters.every(existingFilter => {
          existingFilter = {
            field: existingFilter.field,
            type: existingFilter.type,
            value: existingFilter.value
          }
          return !isEqual(existingFilter, filter)
        })
      })
      if (!setFromAdvancedFilterModal) {
        filters = [...filters, ...this.tableFilters]
      }
      this.table.setFilter(filters)
      this.showFilters = false
    },
    removeFilter(filter) {
      let newValue = null
      const columnExists = this.table.getColumn(filter.field)
      let headerFilterType = 'in'
      if (columnExists) { // handle 'url_attribute'
        headerFilterType = this.table.getColumn(filter.field)._column.definition.headerFilterFunc
      }
      const headerFilterValue = this.table.getHeaderFilterValue(filter.field)
      const headerFilterRemoved = filter.type === headerFilterType && filter.value === headerFilterValue
      if (headerFilterType === 'in') {
        let currentValue = [filter.value]
        if (columnExists) { // handle 'url_attribute'
          currentValue = this.table.getHeaderFilterValue(filter.field).split(/,\s*/)
        }
        newValue = currentValue.filter(value => value !== filter.value)
        newValue = newValue.filter(value => value.trim().length)
        if (!newValue.length) {
          newValue = null
        }
        this.table.setHeaderFilterValue(filter.field, newValue || '')
        let deletedFilter = this.table.getFilters().filter(obj => {
          return obj.field === filter.field && obj.type === filter.type && obj.value.includes(filter.value)
        })
        deletedFilter = deletedFilter.length ? deletedFilter[0] : null
        if (deletedFilter) {
          this.table.removeFilter(filter.field, filter.type, deletedFilter.value)
        }
      } else if (headerFilterRemoved) {
        this.table.setHeaderFilterValue(filter.field, newValue)
      }
      this.table.removeFilter(filter.field, filter.type, filter.value)
    },
    clearFilter(shouldClearHeaders = false) {
      this.table.clearFilter(shouldClearHeaders)
    },
    async openCreateTableViewModal() {
      this.$modal.show('create-table-view')
    },
    async openBulkUpdateModal() {
      this.getUrlTableHelpers(this.selectedClient._id)
      this.$modal.show('bulk-update')
    },
    setTableView(event) {
      this.$modal.hide('create-table-view')
      this.$router.replace({ name: this.$route.name, params: { id: event } })
      this.loadData()
    },
    exportData(event) {
      switch (event) {
        case '#copy-csv':
          this.table.copyToClipboard('table')
          break
        case '#download-csv': {
          const title = moment().format(`[${this.selectedClient.name}]-YYYYMMDD-HHmmss-[export]`)
          this.table.download('csv', `${title}.csv`)
          break
        }
        default:
          if (process.env.VUE_APP_IS_V2_API === 'true') {
            const idx = event.indexOf('url_census')
            event = event.slice(0, idx) + 'rest/v2/' + event.slice(idx)
            event = event.replace('url_census', 'url-census')
          }
          window.location.href = event
      }
    },
    openDataModal(event) {
      switch (event) {
        case 1:
          this.openCreateNew('create-new-url')
          break
        case 2:
          this.getUrlTableHelpers(this.selectedClient._id)
          this.$modal.show('add-urls')
          break
        case 3:
          this.$modal.show('create-section')
          break
        case 4:
          this.$modal.show('create-url-attribute')
          break
      }
    },
    updatePageSize(newSize) {
      this.pageSize = newSize
      this.table.setPageSize(this.pageSize)
    },
    openHistoryModal(url) {
      this.selectedUrl = url
      this.$modal.show('history')
    },
    closeHistoryModal() {
      this.selectedUrl = ''
      this.$modal.hide('history')
    },
    openCreateNew(urlId) {
      this.selectedUrl = urlId
      this.$modal.show('edit-url')
    },
    urlGauge() {
      return this.totalUrlCount === this.filteredUrlCount ? `${this.totalUrlCount.toLocaleString('en')}` : `${this.filteredUrlCount.toLocaleString('en')} / ${this.totalUrlCount.toLocaleString('en')}`
    },
    msvGauge(msv) {
      return msv.score === this.filteredMsv[msv.field] ? `${msv.score.toLocaleString('en')}` : `${this.filteredMsv[msv.field].toLocaleString('en')} / ${msv.score.toLocaleString('en')}`
    },
    mappedUrlGauge() {
      return this.allMappedUrls === this.filteredMappedUrls ? `${this.allMappedUrls.toLocaleString('en')}` : `${this.filteredMappedUrls.toLocaleString('en')} / ${this.allMappedUrls.toLocaleString('en')}`
    },
    rankingUrlGauge() {
      return this.allRankingUrls === this.filteredRankingUrls ? `${this.allRankingUrls.toLocaleString('en')}` : `${this.filteredRankingUrls.toLocaleString('en')} / ${this.allRankingUrls.toLocaleString('en')}`
    },
    getPercentString(part, total) {
      return (part === total || total === 0) ? '100%' : `${(part / total * 100).toFixed(2)}%`
    },
    updateOrRemoveColumn(columnName, tableColumnsCopy) {
      const idx = tableColumnsCopy.findIndex(col => col.field === columnName)
      if (columnName.startsWith('msv_')) {
        let labelTitle
        switch (columnName) {
          case 'msv_1_total':
            labelTitle = 'metric_msv_broad_adjusted_1'
            break
          case 'msv_2_total':
            labelTitle = 'metric_msv_broad_adjusted_2'
            break
          case 'msv_3_total':
            labelTitle = 'metric_msv_broad_adjusted_3'
            break
          case 'msv_4_total':
            labelTitle = 'metric_msv_broad_adjusted_4'
            break
          default:
            labelTitle = 'metric_msv_broad_adjusted_1'
        }
        if (this.msvLabels[labelTitle]) {
          tableColumnsCopy[idx].title = this.msvLabels[labelTitle]
          fieldLabels[columnName] = this.msvLabels[labelTitle]
        } else {
          tableColumnsCopy.splice(idx, 1)
          delete this.filterFieldOrder[columnName]
        }
      }
    },
    // loadData was getting called twice on initial page load - this is a hack and should be fixed
    debouncedLoadData: debounce(async (cb) => {
      cb()
    }, 250),
    loadData() {
      this.debouncedLoadData(this.loadTableData)
    },
    async loadTableData() {
      this.isDataUpdating = true
      this.isDataLoading = true
      let selectedClientId = this.selectedClient._id
      let savedViewData = {}
      const savedViewHash = this.$route.params.id
      if (savedViewHash) {
        const savedView = await this.getTableView({ data: savedViewHash, clientId: selectedClientId })
        if (savedView.data.client_id) {
          this.setNewClient(savedView.data.client_id, true)
          selectedClientId = savedView.data.client_id
        }
        if (!savedView.errors.length) {
          savedViewData = savedView.data.data
        }
        this.$route.params.id = null
      }
      this.tableHelpers = await this.getUrlTableHelpers(selectedClientId)
      let savedViews = await this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id, type: 'url_census' })
      this.savedViews = savedViews
      this.isDataUpdating = false
      if (this.tableHelpers) {
        this.filterFieldOrder = cloneDeep(order)
        this.loadTable(savedViewData)
      }
    },
    async applyBulkUpdate(form) {
      this.sendRequestFromModal('bulk-update', this.postBulkUpdate({ clientId: this.selectedClient._id, form }))
    },
    async applyUrls(form) {
      this.sendRequestFromModal('add-urls', this.postUrls({ clientId: this.selectedClient._id, form }))
    },
    async applySection(section) {
      this.sendRequestFromModal('create-section', this.createSection({ clientId: this.selectedClient._id, section }))
    },
    async applyUrlAttribute(urlAttribute) {
      this.sendRequestFromModal('create-url-attribute', this.createurlAttribute({ clientId: this.clientId, urlAttribute }))
    },
    async applySaveTableView({ details, tableViewId, closeModal = true }) {
      const data = await this.patchTableView({ details, tableViewId, clientId: this.selectedClient._id })
      if (data.errors.length) {
        data.errors.forEach(err => {
          ToasterService.showToast(ToasterService.ERROR_TYPE, err)
        })
      } else {
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Saved Table View!')
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
        if (closeModal) {
          this.$modal.hide('create-table-view')
        } else {
          this.savedViews = await this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id, type: 'url_census' })
        }
        if (data.created) {
          this.$modal.hide('create-table-view')
        }
      }
    },
    async handleDeleteTableView({ tableViewId, closeModal = true }) {
      const data = await this.deleteTableView({ tableViewId, clientId: this.selectedClient._id })
      if (data.errors.length) {
        data.errors.forEach(err => {
          ToasterService.showToast(ToasterService.ERROR_TYPE, err)
        })
      } else {
        ToasterService.showToast(ToasterService.SUCCESS_TYPE, 'Deleted Table View!')
        this.handleTableViewDataChange(this.getUpdatedTableViewData())
        if (closeModal) {
          this.$modal.hide('create-table-view')
        } else {
          this.savedViews = await this.getSavedViews({ userId: this.currentUser._id, clientId: this.selectedClient._id, type: 'url_census' })
        }
      }
    },
    async sendRequestFromModal(modalName, request) {
      this.isDataUpdating = true
      try {
        await request
        this.table.setData()
        this.$modal.hide(modalName)
      } catch (e) {
        this.$refs[modalName].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
        if (['create-section'].includes(modalName)) {
          this.getUrlTableHelpers(this.selectedClient._id).then(() => {
            if (modalName === 'create-section') {
              Object.assign(this.sectionValues, this.sections)
            }
          })
        }
      }
    },
    loadTable(savedParams) {
      savedParams = Object.keys(savedParams).length ? savedParams : null
      let tableColumnsCopy = cloneDeep(tableColumns)
      if (savedParams) {
        if (savedParams.columns && savedParams.columns.length) {
          localStorage.removeItem('tabulator-urlc_table-columns')
          // First hide all fields to account for any recently created columns
          tableColumnsCopy.forEach(col => col.visible = false)
          savedParams.columns.forEach(savedCol => {
            const column = tableColumnsCopy.find(col => col.field === savedCol.field)
            Object.assign(column, savedCol)
          })
        }
        if (savedParams.sorters && savedParams.sorters.length) {
          const sortHelper = savedParams.columns.map(obj => obj.field)
          tableColumnsCopy.sort((a, b) => {
            return sortHelper.indexOf(a.field) - sortHelper.indexOf(b.field)
          })
        }
        if (this.table) {
          this.table.setColumnLayout(tableColumnsCopy)
        }
      }

      tableColumnsCopy.forEach(col => {
        if (col.cellDblClick || col.cellClick || col.cellContext) {
          col.titleFormatter = () => {
            return `${col.title}&nbsp;&nbsp;${this.rawIconQuestionHtmlString}`
          }
          col.headerTooltip = () => {
            let definitions = ''
            if (col.cellClick) {
              definitions += col.cellClickDescription + '\n'
            }
            if (col.cellDblClick) {
              definitions += col.cellDblClickDescription + '\n'
            }
            if (col.cellContext) {
              definitions += col.cellContextDescription + '\n'
            }
            return `${col.title}\n\n${definitions}`
          }
        }
      })

      this.updateOrRemoveColumn('msv_1_total', tableColumnsCopy)
      this.updateOrRemoveColumn('msv_2_total', tableColumnsCopy)
      this.updateOrRemoveColumn('msv_3_total', tableColumnsCopy)
      this.updateOrRemoveColumn('msv_4_total', tableColumnsCopy)

      const handleOpenEdit = (e, cell) => {
        this.openCreateNew(cell._cell.row.data._id)
      }
      const editButtonColumn = tableColumnsCopy.find(col => col.field === 'edit_button')
      editButtonColumn.cellClick = handleOpenEdit
      editButtonColumn.formatter = () => {
        return this.rawIconPencilHtmlString
      }

      tableColumnsCopy.find(col => col.field === 'is_optimized').cellDblClick = handleOpenEdit
      tableColumnsCopy.find(col => col.field === 'keyword_score_average').cellDblClick = handleOpenEdit

      const msv1Column = tableColumnsCopy.find(col => col.field === 'msv_1_total')
      const msv2Column = tableColumnsCopy.find(col => col.field === 'msv_2_total')
      const msv3Column = tableColumnsCopy.find(col => col.field === 'msv_3_total')
      const msv4Column = tableColumnsCopy.find(col => col.field === 'msv_4_total')
      const editUrlDescription = 'double-click cell to edit URL'
      if (msv1Column) {
        msv1Column.cellDblClick = handleOpenEdit
        msv1Column.cellDblClickDescription = editUrlDescription
      }
      if (msv2Column) {
        msv2Column.cellDblClick = handleOpenEdit
        msv2Column.cellDblClickDescription = editUrlDescription
      }
      if (msv3Column) {
        msv3Column.cellDblClick = handleOpenEdit
        msv3Column.cellDblClickDescription = editUrlDescription
      }
      if (msv4Column) {
        msv4Column.cellDblClick = handleOpenEdit
        msv4Column.cellDblClickDescription = editUrlDescription
      }

      const urlStatusColumn = tableColumnsCopy.find(col => col.field === 'url_status')
      urlStatusColumn.cellDblClick = handleOpenEdit
      urlStatusColumn.cellDblClickDescription = editUrlDescription
      urlStatusColumn.editorParams.values = this.urlStatuses
      urlStatusColumn.mutator = (value) => {
        return this.urlStatuses[value] === undefined ? value : this.urlStatuses[value]
      }
      urlStatusColumn.headerFilterParams.values = Object.values(this.tableHelpers.url_statuses)

      const contentBriefStatusColumn = tableColumnsCopy.find(col => col.field === 'content_brief_status')
      contentBriefStatusColumn.editorParams.values = this.contentBriefStatuses
      contentBriefStatusColumn.mutator = (value) => {
        return this.contentBriefStatuses[value] === undefined ? value : this.contentBriefStatuses[value]
      }
      contentBriefStatusColumn.headerFilterParams.values = Object.values(this.tableHelpers.content_brief_statuses)

      const assignedWriterColumn = tableColumnsCopy.find(col => col.field === 'assigned_writer')
      assignedWriterColumn.editorParams.values = [{ label: 'Remove Writer', value: -1 }, ...this.formattedUsersList]
      assignedWriterColumn.mutator = (value) => {
        return this.formattedUsers[value]
      }
      assignedWriterColumn.headerFilterParams.values = ['- blank -', ...Object.values(this.formattedUsers)]

      const assignedStrategistColumn = tableColumnsCopy.find(col => col.field === 'assigned_strategist')
      assignedStrategistColumn.editorParams.values = [{ label: 'Remove Strategist', value: -1 }, ...this.formattedUsersList]
      assignedStrategistColumn.mutator = (value) => {
        return this.formattedUsers[value]
      }
      assignedStrategistColumn.headerFilterParams.values = ['- blank -', ...Object.values(this.formattedUsers)]

      const pageTypeColumn = tableColumnsCopy.find(col => col.field === 'page_type')
      pageTypeColumn.cellDblClick = handleOpenEdit
      pageTypeColumn.cellDblClickDescription = editUrlDescription
      pageTypeColumn.editorParams.values = this.pageTypes
      pageTypeColumn.mutator = (value) => {
        return this.pageTypes[value] === undefined ? value : this.pageTypes[value]
      }
      pageTypeColumn.headerFilterParams.values = ['- blank -', ...Object.values(this.tableHelpers.page_types)]

      const writingStatusColumn = tableColumnsCopy.find(col => col.field === 'writing_status')
      writingStatusColumn.editorParams.values = this.writingStatuses
      writingStatusColumn.mutator = (value) => {
        return this.writingStatuses[value] === undefined ? value : this.writingStatuses[value]
      }
      writingStatusColumn.headerFilterParams.values = ['- blank -', ...Object.values(this.tableHelpers.writing_statuses)]

      const sectionNameColumn = tableColumnsCopy.find(col => col.field === 'section_name')
      sectionNameColumn.cellDblClick = handleOpenEdit
      sectionNameColumn.cellDblClickDescription = editUrlDescription
      sectionNameColumn.editorParams.values = this.sectionValues = {}
      Object.assign(this.sectionValues, this.sections)
      sectionNameColumn.mutator = (value) => {
        return this.sections[value] === undefined ? value : this.sections[value]
      }
      sectionNameColumn.headerFilterParams.values = ['- blank -', ...Object.values(this.tableHelpers.sections)]

      const targetDateColumn = tableColumnsCopy.find(col => col.field === 'publish_date')
      targetDateColumn.cellDblClick = handleOpenEdit
      targetDateColumn.cellDblClickDescription = editUrlDescription
      targetDateColumn.editor = 'input'
      targetDateColumn.editorParams = {
        mask: '9999-99-99',
        maskAutoFill: true
      }

      const httpResponseCodeColumn = tableColumnsCopy.find(col => col.field === 'http_response_code')
      httpResponseCodeColumn.headerFilterParams.values = Object.values(this.tableHelpers.http_statuses)

      const linksColumn = tableColumnsCopy.find(col => col.field === 'link_count')
      linksColumn.cellDblClick = async (e, cell) => {
        const routeData = this.$router.resolve({ path: `/data/link?fk_url_id=${cell._cell.row.data._id}` });
        window.open(routeData.href, '_blank');
      }

      const keywordColumn = tableColumnsCopy.find(col => col.field === 'keyword_count')
      keywordColumn.cellDblClick = async (e, cell) => {
        const url = cell._cell.row.data.url
        const form = {
          'filters': [{
            'field': 'url',
            'type': '=',
            'value': url
          }]
        }
        const data = await this.postTableView({ form: form, clientId: this.selectedClient._id, type: 'keyword_census' })
        const routeData = this.$router.resolve({ path: `/strategy/keyword-census/${data.data}` });
        window.open(routeData.href, '_blank');
      }

      const vueComponent = this
      this.table = new Tabulator(this.$refs.table, {
        data: vueComponent.tableData,
        height: '100%',
        pageLoaded: () => {
          // issue with tabulator not always rendering all rows - this forces a redraw
          vueComponent.table.redraw()
        },
        persistenceID: 'urlc_table',
        persistenceMode: 'local',
        persistence: {
          columns: ['width', 'visible', 'frozen']
        },
        clipboard: 'copy',
        clipboardCopyRowRange: 'active',
        clipboardCopyConfig: {
          columnHeaders: false, // do not include column headers in clipboard output
          // columnGroups:false, // do not include column groups in column headers for printed table
          // rowGroups:false, // do not include row groups in clipboard output
          columnCalcs: false // do not include column calculation rows in clipboard output
          // dataTree:false, // do not include data tree in printed table
          // formatCells:false, // show raw cell values without formatter
        },
        clipboardCopied() {
          ToasterService.showToast(ToasterService.INFO_TYPE, 'Copied to clipboard')
        },
        autoResize: true,
        layout: 'fitColumns',
        resizableColumns: true,
        movableColumns: true,
        headerSortTristate: true,
        headerSortElement: "<i class='fas fa-caret-up'></i>",
        paginationSize: 100,
        selectable: true,
        headerFilterPlaceholder: '',
        initialSort: savedParams && savedParams.sorters ? savedParams.sorters : [
          {
            column: 'publish_date',
            dir: 'desc'
          }
        ],
        initialFilter: savedParams && savedParams.filters ? savedParams.filters : null,
        tooltips(cell) {
          if (cell._cell.column.field === 'http_response_code' && cell.getValue()) {
            return vueComponent.getHttpStatusText(cell.getValue())
          }
          return cell.getValue()
        },
        tooltipsHeader: true,
        pagination: 'remote',
        ajaxSorting: true,
        ajaxFiltering: true,
        ajaxURL: '/rest/url-census/table',
        // ajaxConfig: 'POST', // ajax HTTP request type
        ajaxContentType: 'json', // send parameters to the server as a JSON encoded string
        ajaxParams: { client_id: vueComponent.clientId },
        ajaxConfig: {
          method: "POST", //set request type to Position
          headers: {
            "Content-type": 'application/json; charset=utf-8', //set specific content type
            "resource-page": vueComponent.$router.currentRoute.path,
          },
        },
        columns: tableColumnsCopy,
        ajaxRequesting() {
          vueComponent.updateFilters()
        },
        ajaxResponse(url, params, response) {
          vueComponent.filteredUrlCount = response._filtered_urls.length
          vueComponent.filteredUrls = response._filtered_urls
          vueComponent.totalUrlCount = response._total_urls.length
          vueComponent.urlAttributeData = response._url_attribute_data

          vueComponent.webPropertyPatterns = response._web_property_patterns

          vueComponent.isDataLoading = false
          return response
        },
        async cellEdited(cell) {
          const _resolve_id = (items, k) => {
            for (let i in items) {
              if (items[i] === k) {
                return i
              }
            }
          }
          let params = {
            table: 'url',
            field: cell._cell.column.field,
            value: cell._cell.value,
            id: cell._cell.value,
            pk: cell._cell.row.data.id
          }
          if (cell._cell.column.field === 'page_type') {
            let _id = _resolve_id(vueComponent.pageTypes, cell._cell.value)
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: _id,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'writing_status') {
            let _id = _resolve_id(vueComponent.writingStatuses, cell._cell.value)
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: vueComponent.clientId,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'content_brief_status') {
            let _id = _resolve_id(vueComponent.contentBriefStatuses, cell._cell.value)
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: vueComponent.clientId,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'assigned_writer') {
            let _id = _resolve_id(vueComponent.formattedUsers, cell._cell.value)
            _id = (_id && cell._cell.value !== -1) ? _id : -1
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: vueComponent.clientId,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'assigned_strategist') {
            let _id = _resolve_id(vueComponent.formattedUsers, cell._cell.value)
            _id = (_id && cell._cell.value !== -1) ? _id : -1
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: vueComponent.clientId,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'url_status') {
            let _id = _resolve_id(vueComponent.urlStatuses, cell._cell.value)
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: vueComponent.clientId,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'section_name') {
            let _id = _resolve_id(vueComponent.sections, cell._cell.value)
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _id,
              id: _id,
              pk: cell._cell.row.data.id
            }
          } else if (cell._cell.column.field === 'is_optimized') {
            let _value = 0
            if (cell._cell.value === 'Yes') {
              _value = 1
            }
            params = {
              table: 'url',
              field: cell._cell.column.field,
              value: _value,
              id: _value,
              pk: cell._cell.row.data.id
            }
          }
          /// ////////////////
          // let params = {
          //   field: cell._cell.column.field,
          //   value: cell._cell.value,
          //   pk: cell._cell.row.data.id
          // }
          // if (cell._cell.column.field === 'url') {
          //   const regExp = /\(([^)]+)\)/
          //   const matches = regExp.exec(cell._cell.value)
          //   const _id = matches[1]

          //   params = {
          //     field: 'fk_url_id',
          //     value: _id,
          //     pk: cell._cell.row.data.id
          //   }
          // }
          const response = await vueComponent.updateField({ form: params })
          if (cell._cell.column.field === 'publish_date') {
            if (!response) {
              cell.restoreOldValue()
            } else {
              vueComponent.table.replaceData()
            }
          } else if (cell._cell.column.field === 'url_status' && cell._cell.value.toLowerCase() === 'deleted') {
            vueComponent.table.replaceData()
          }
        }
      })
    }
  },
  created() {
    if (this.selectedClient) {
      this.loadData()
    }
  },
  mounted() {
    this.rawIconPencilHtmlString = this.$refs.iconPencil.$el.outerHTML.toString()
    this.$refs.iconPencil.$el.parentNode.removeChild(this.$refs.iconPencil.$el)
    this.rawIconQuestionHtmlString = this.$refs.iconQuestion.$el.outerHTML.toString()
    this.$refs.iconQuestion.$el.parentNode.removeChild(this.$refs.iconQuestion.$el)
  }
}

</script>

<style lang="scss">
.tabulator-edit-select-list {
  padding: 4px;
  background-color: #f4fbfa;
  color: white;
}

.tabulator-header-filter {
  >input {
    outline: none;
    border: none;
    border-bottom: 1px solid #7D8F9D;
  }
}

.tabulator {
  border: none;
}

.tabulator-calcs {
  color: #7c8e9b;
}

.tabulator-col-title {
  color: #011627;
}

/* Define the style when the column is not sorted */
.tabulator-col[aria-sort="none"] .tabulator-col-sorter i {
  color: #999;
  font-size: 20px;
}

/* Define the style when the column is sorted in ascending order */
.tabulator-col[aria-sort="asc"] .tabulator-col-sorter i {
  color: $rfx-bright-blue;
  font-size: 20px;
}

/* Define the style when the column is sorted in descending order */
.tabulator-col[aria-sort="desc"] .tabulator-col-sorter i {
  color: $rfx-bright-blue;
  transform: scaleY(-1);
  /* flip the icon vertically so the arrow points down */
  font-size: 20px;
}
</style>

<style scoped lang="scss">
#export-tab-dropdown {
  height: 20px !important;
  padding: 5px;
  cursor: pointer;
}

#export-tab-dropdown-container {
  padding: 0;
}

#add-tab-dropdown {
  height: 20px !important;
  padding: 5px;
  cursor: pointer;
}

#add-tab-dropdown-container {
  padding: 0;
}

.container {
  margin: auto;
  margin-top: 10px;
  width: 100%;
}

ul {
  list-style: none;
}

.gauge-td {
  text-align: right;
}

.gauge-td-mid {
  white-space: nowrap;
}

#main-table {
  margin-top: 30px;
}

.progress-ring {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
}

.metrics {
  margin-top: 10px;
  margin-right: 25px;
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &__metric {
    display: block;
    font-size: 11px;
    font-weight: bold;
    color: #7c8e9b;
    height: 13px;

    &__filtered {
      font-size: 20px;
      color: #011627;
    }
  }
}

.urlc {

  &__button {
    width: 136px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: $rfx-medium-march;
    color: #fff;
    position: relative;
  }

  &__title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title-left {
    width: 80%;
    display: flex;
  }

  &__title-right {
    display: flex;
  }

  &__update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    opacity: 0.5;
    z-index: 10000;
  }

  &__update-loader-ring {
    margin-top: 200px;
  }

  &__filter_pills {
    margin: 5px 20px;
    width: 75%;
  }

  &__filter_pills {
    margin: 5px 20px;
    width: 75%;
  }

  &__tabs {
    display: grid;
    width: 50%;
    margin: 5px 0;
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    height: 40px;
    flex: 15%;
    height: 34px;

    &.function-tabs {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    &.page-tabs {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  &__select {
    width: 160px;
  }

  &__buttons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__tab {
    font-weight: 500;
    outline: none;
    font-size: 10px;
    border: 1px solid $rfx-light-steel;
    color: $rfx-dark-march;
    margin: 0;
    cursor: pointer;
    transition: box-shadow .3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    text-decoration: none;
    padding: 5px;

    &:hover {
      /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;

    }

    &_center {
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
    }

    &_disabled {
      pointer-events: none;
      cursor: default;
    }

    &_active {
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;
    }

    &__enabled {
      color: $rfx-bright-blue
    }
  }

  &__icon {
    font-size: 20px;
  }

  &__gauge-container {
    width: 400px;
    margin: 30px 0;
    font-size: 12px;
    font-weight: 900;
  }

  &__gauge-span {
    float: right;
  }

  &__filters {
    width: 750px;
    position: absolute;
    z-index: 99;
    background-color: white;
    border-radius: 13px;
    text-align: left;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 20px;

    &_header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    }

    &_title {
      font-size: 16px;
      font-weight: 500;
    }

    &_close {
      cursor: pointer;
    }
  }
}
</style>
